/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export * from './security.options';
export * from './security.module';
export * from './services/acl.service';
export * from './services/access-checker.service';
export * from './services/role.provider';
//# sourceMappingURL=index.js.map